export default class SizeTranslator {
  static bytesToMB(bytes: number) {
    return bytes / 1000 / 1024;
  }
}
